import React, { useEffect, useState } from "react";
import styles from "./../cruise.module.css";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../../component/table";
import { deleteIcon, editIcon } from "../../../../utils/svg.file";

import { Featured_URL, Offers_URL } from "../../../../serverUrl";
import DeleteModal from "../../../component/modal/deleteModal";
import swal from "sweetalert";
import {
  deleteCruise,
  showCruiseList,
  showRestaurantBanner,
  showRetreatBanner,
} from "../../../../api/adminPanel/giftCardApi";
import { Box } from "@mui/material";

export default function ManageCruisePackageAndDetail() {
  const navigate = useNavigate();
  const [bannerList, setbannerList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState("");
  const [deleteId, setDeletedId] = useState("");
  const [showListModal, setShowListModal] = useState("");

  const handleShowDeleteModal = (id) => {
    setDeletedId(id);
    setShowDeleteModal(true);
  };
  const hideDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleShowListModal = (id) => {
    setShowListModal(true);
    setShowDeleteModal(false);
  };
  const hideListModal = () => {
    setShowListModal(false);
  };

  const handelRetreatBanner = async () => {
    const response = await showCruiseList();
    if (response.remote === "success") {
      setbannerList(response.data.data);
    } else {
    }
  };

  const handleDelete = async (id) => {
    const response = await deleteCruise(id);

    if (response.remote === "success") {
      hideDeleteModal();
      swal("Deleted Successfully!");
      handelRetreatBanner();
    } else {
    }
  };
  const columns = [
    { field: "id", headerName: "SNo.", width: 100 },
    {
      field: "image",
      height: 150,
      width: 300,
      renderCell: (cellValues) => {
        return (
          <>
            <img
              src={`${Offers_URL}${cellValues.row.image}`}
              className={styles.table_img}
            />
          </>
        );
      },
    },
    { field: "title", headerName: "Title", width: 400 },
    { field: "shortDescription", headerName: "Description", width: 400 },

    {
      field: "Action",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>
            <span
              className={styles.edit_icon_btn}
              onClick={() => {
                navigate(
                  `/edit-cruise-package-and-detail/${cellValues.row.id}`
                );
              }}
            >
              {editIcon}
            </span>
            <span
              className={styles.delete_icon_btn}
              onClick={() => {
                handleShowDeleteModal(cellValues.row.id);
              }}
            >
              {deleteIcon}
            </span>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    handelRetreatBanner();
  }, []);

  // let rows = [
  //   { id: 1, image: "dsd", shortDescription: "fdsdfggs" },
  //   { id: 2, image: "dsds", shortDescription: "fdsdfggs" },
  // ];
  let rows = [];

  bannerList?.map((item, index) => {
    rows.push({
      id: item.id,
      image: item.cardImage,
      shortDescription: item.shortDescription,
      title: item.title,
    });
  });
  return (
    <>
      <div className={styles.job_list_page}>
        <div className="">
          <div className={styles.card_body}>
            <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
              <div className={styles.page_title}>
                <h3>Manage Activity And Detail</h3>
              </div>
              <Button
                className={styles.main_button}
                onClick={() => navigate("/add-cruise-package-and-detail")}
              >
                Add
              </Button>
            </div>
            <Table rows={rows} columns={columns} />
          </div>
        </div>
      </div>
      <Modal show={showDeleteModal} onHide={hideDeleteModal}>
        <Modal.Body className="text-center">
          <h4> Are You Sure You want to Deletes ?</h4>
          <div className="w-100 mt-3">
            {" "}
            <Button variant="secondary" onClick={hideDeleteModal}>
              Close
            </Button>
            <Button
              className="ms-4"
              variant="danger"
              onClick={() => {
                handleDelete(deleteId);
              }}
            >
              Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* -==-=-=--=-=-=-=-List show modal-=-=-=-=-=- */}
      <Modal show={showListModal} onHide={hideListModal}>
        <Modal.Body className="text-center">
          <Box>
            <h4>
              This category has been added bleow stories move given stories in
              other categories then you''ll be able to delete category.
            </h4>
            <Box sx={{ textAlign: "left" }} className="modal_list">
              <ul className={styles.border_list}>
                {/* {retreatList?.map((item) => (
                  <li className={styles.list_item}>
                    {item.title} - {item.country}
                  </li>
                ))} */}
                text
              </ul>
            </Box>
            <div className="w-100 mt-3 text-center">
              <Button variant="secondary" onClick={hideListModal}>
                Close
              </Button>
            </div>
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
}
